import React, { useRef } from "react";
import "./FlagSlider.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import { medialUrl } from "../../../EndPoints";

import MexicoFlag from "../../../assets/images/flags/mexico.png";
import SingaporeFlag from "../../../assets/images/flags/singapore.png";
import SpainFlag from "../../../assets/images/flags/spain.png";
import UnitedKingdomFlag from "../../../assets/images/flags/uk.png";
import IrelandFlag from "../../../assets/images/flags/ireland.png";
import AustraliaFlag from "../../../assets/images/flags/australia.png";
import SwitzerlandFlag from "../../../assets/images/flags/switzerland.png";
import BelgiumFlag from "../../../assets/images/flags/belgium.png";
import FranceFlag from "../../../assets/images/flags/france.png";
import GermanyFlag from "../../../assets/images/flags/germany.png";
import CanadaFlag from "../../../assets/images/flags/canada.png";
import DenmarkFlag from "../../../assets/images/flags/denmark.png";
import GreeceFlag from "../../../assets/images/flags/greece.png";
import IndiaFlag from "../../../assets/images/flags/india.png";
import ItalyFlag from "../../../assets/images/flags/italy.png";
import NetherlandsFlag from "../../../assets/images/flags/netherlands.png";
import SwedenFlag from "../../../assets/images/flags/sweden.png";
import UnitedStatesFlag from "../../../assets/images/flags/us.png";

// const logo1 = `${medialUrl}/images/flags/Mexico.png`;
// const logo2 = `${medialUrl}/images/flags/Singapore.png`;
// const logo3 = `${medialUrl}/images/flags/Spain.png`;
// const logo4 = `${medialUrl}/images/flags/United_Kingdom.png`;
// const logo5 = `${medialUrl}/images/flags/Ireland.png`;
// const logo6 = `${medialUrl}/images/flags/Austria.png`;
// const logo7 = `${medialUrl}/images/flags/Switzerland.png`;
// const logo8 = `${medialUrl}/images/flags/Belgium.png`;
// const logo9 = `${medialUrl}/images/flags/France.png`;
// const logo10 = `${medialUrl}/images/flags/Germany.png`;

export default function LogoSlider() {
  const swiperRef = useRef();
  return (
    <div className="mb-5 mt-10 flex flex-col justify-center items-center content-center">
      <h1 className="text-[32px] font-Playfair pb-2">We Export Worldwide</h1>

      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        spaceBetween={3}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        slidesPerView={5} // Default slidesPerView
        loop
        className="w-full h-auto my-[40px]"
        breakpoints={{
          640: {
            slidesPerView: 6,
          },
          340: {
            slidesPerView: 2,
          },
        }}
      >
        <div className="flex flex-col gap-5 mx-auto justify-center items-center">
          {flagContent1.map((el, i) => {
            return (
              <SwiperSlide key={i} className="flex justify-center items-center">
                <div className="flag flex flex-col justify-center items-center">
                  <img src={el.src} alt={el.country} className="shadow" />
                  <p className="text-center font-Poppins font-semibold">
                    {el.country}
                  </p>
                </div>
              </SwiperSlide>
            );
          })}
        </div>
      </Swiper>

      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        spaceBetween={3}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        slidesPerView={5} // Default slidesPerView
        loop
        className="w-full h-auto my-[40px]"
        breakpoints={{
          640: {
            slidesPerView: 6,
          },
          340: {
            slidesPerView: 2,
          },
        }}
      >
        <div className="flex flex-col gap-5 mx-auto justify-center items-center">
          {flagContent2.map((el, i) => {
            return (
              <SwiperSlide key={i} className="flex justify-center items-center">
                <div className="flag flex flex-col justify-center items-center">
                  <img src={el.src} alt={el.country} className="shadow" />
                  <p className="text-center font-Poppins font-semibold">
                    {el.country}
                  </p>
                </div>
              </SwiperSlide>
            );
          })}
        </div>
      </Swiper>

      <div className="mt-10 flex flex-row flex-wrap gap-5 md:gap-32 mx-auto justify-center items-center">
        <div className="flag flex flex-col justify-center items-center">
          <img src={MexicoFlag} alt="Mexico" className="shadow" />
          <p className="text-center font-Poppins font-semibold">Mexico</p>
        </div>

        <div className="flag flex flex-col justify-center items-center">
          <img src={SingaporeFlag} alt="Singapore" className="shadow" />
          <p className="text-center font-Poppins font-semibold">Singapore</p>
        </div>
      </div>
    </div>
  );
}

const flagContent1 = [
  { src: MexicoFlag, country: "Mexico" },
  { src: SingaporeFlag, country: "Singapore" },
  { src: SpainFlag, country: "Spain" },
  { src: UnitedKingdomFlag, country: "United Kingdom" },
  { src: IrelandFlag, country: "Ireland" },
  { src: AustraliaFlag, country: "Australia" },
  { src: SwitzerlandFlag, country: "Switzerland" },
  { src: BelgiumFlag, country: "Belgium" },
];

const flagContent2 = [
  { src: FranceFlag, country: "France" },
  { src: GermanyFlag, country: "Germany" },
  { src: CanadaFlag, country: "Canada" },
  { src: DenmarkFlag, country: "Denmark" },
  { src: GreeceFlag, country: "Greece" },
  { src: IndiaFlag, country: "India" },
  { src: ItalyFlag, country: "Italy" },
  { src: NetherlandsFlag, country: "Netherlands" },
  { src: SwedenFlag, country: "Sweden" },
  { src: UnitedStatesFlag, country: "United States" },
];
